import { COLORS } from "@dehaat/dds";
import { LAND_UNITS } from "../models/farmer";

export const AREA_UNITS = [
  {
    id: LAND_UNITS.ACRES,
    value: LAND_UNITS.ACRES,
  },
  {
    id: LAND_UNITS.HECTARE,
    value: LAND_UNITS.HECTARE,
  },
];

export enum GENDER {
  MALE = "Male",
  FEMALE = "Female",
}

export const DEFAULT_AVATOR_COLORS = [
  COLORS.mulberry100,
  COLORS.success100,
  COLORS.olive100,
  COLORS.blue100,
  COLORS.error100,
  COLORS.neutral100,
  COLORS.orange100,
  COLORS.purple100,
];

export const NAVIGATION_FROM_APP_CODE = "appCode";
export const AIMS_APP_CODE = "aimsapp";
export const VR_APP_CODE = "vr-service";
export const ASSUMED_USER_NAME = "assumed-user-name";
export const ASSUMED_USER_NUMBER = "assumed-user-number";
export const AGC_APP_CODE = "agc-dehaat";
export const SRP_APP_CODE = "srp-app";
export const AGC_MOE_DID = "agc-moe-did";

export const APP_CODES = {
  AGC: "05",
};
